export default __webpack_public_path__ + "static/media/winner_3.dd99eabe.jpg";